import { Injectable } from '@angular/core';

/**
 * Wrapper around window.location to enable better test coverage
 */
@Injectable({ providedIn: 'root' })
export class LocationService {
  // Ignoring testing because there's no reliable way to test location.href
  public go(url: string, newTab = false) {
    if (newTab) {
      window.open(url, '_blank', 'noreferrer,noopener');
    } else {
      window.location.href = url;
    }
  }

  // Ignoring testing because there's no reliable way to test location.reload
  public reload() {
    window.location.reload();
  }

  // Ignoring testing becaues there's no reliable way to test location.pathname
  // and location.search
  public path() {
    return window.location.pathname + window.location.search;
  }
}
